var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .5h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.2222 18.7222h-12.44442v-12.44442h6.22222v-1.77778h-6.22222c-.98667 0-1.77778.8-1.77778 1.77778v12.44442c0 .9778.79111 1.7778 1.77778 1.7778h12.44442c.9778 0 1.7778-.8 1.7778-1.7778v-6.2222h-1.7778zm-4.4444-14.2222v1.77778h3.1911l-8.73779 8.73782 1.25333 1.2533 8.73776-8.73779v3.19109h1.7778v-6.2222z"
  }))));
};
export default SvgExternal;